import { Class } from '../../../../../db/classes/types';
import { Poll } from '../../../../../db/polls/types';
import { ToBeDone } from '../../../../../db/types';
import i18n, { i18nNS } from '../../../../../i18n';
import { getIsPollPublishable, getIsScheduledEndTimeInPast } from '../../helpers';

export const getPublishAlertMessage = (cls: Class | null, poll: Poll | null, totalQuestions: number) => {
  if (!cls) return '';
  if (!poll) return '';

  const isPollPublishable = getIsPollPublishable(poll, cls.startTime, cls.endTime);

  if (isPollPublishable) {
    if (totalQuestions === 0) {
      return i18n.t('please_add_a_poll_question_and_try_again', {
        ns: i18nNS.POLL,
      });
    }
    return '';
  }

  if (poll.toBeDone === ToBeDone.PRE_CLASS) {
    return i18n.t(
      'you_can_only_publish_an_activity_in_an_upcoming_or_ongoing_class_that_has_not_been_cancelled_consider_moving_or_copying_this_activity_to_share_it_with_students',
      { ns: i18nNS.POLL }
    );
  }

  const isClassEnded = getIsScheduledEndTimeInPast(cls.endTime);
  if (isClassEnded) {
    return i18n.t('an_in_class_activity_can_only_be_published_during_lecture_hours', { ns: i18nNS.POLL });
  }

  return i18n.t(
    'you_can_publish_an_in_class_activity_only_once_it_s_time_for_your_class_and_you_have_started_your_class_on_acadly',
    { ns: i18nNS.POLL }
  );
};
